export default __webpack_public_path__ + "static/media/weather.b445b555.png";